export default "/directory/static/printing_available.3874c852.svg";